import React from "react";

import { StyledAnchor, StyledLinkProps } from "./styles";

interface FancyAnchorLinkProps extends StyledLinkProps {
  href: string;
  target?: string;
  rel?: string;
}

export const FancyAnchorLink: React.FC<FancyAnchorLinkProps> = ({
  children,
  ...rest
}) => (
  <StyledAnchor {...rest}>
    <span>{children}</span>
  </StyledAnchor>
);
